<script>
import { CostAllocationFormComponent } from '@/../refactor-dist/refactor-module';
import allCostAllocationMock from '@/domains/Test/views/CostAllocation/allCostAllocation';
import myCostAllocationMock from '@/domains/Test/views/CostAllocation/myCostAllocation';
import { COMPONENT_EVENTS } from '@/constants';

export default {
  name: 'CostAllocationView',
  components: {
    CostAllocationFormComponent,
  },
  data() {
    return {
      allCostAllocationMock,
      myCostAllocationMock,
      form: {},
      text: {},
    };
  },
  computed: {
    costAllocationFormComponentProps() {
      return {
        items: allCostAllocationMock,
        acceptButton: {
          text: 'Test',
          isDisabled: !this.$data.form.valid,
        },
        form: this.form,
        text: this.text,
      };
    },
  },
  created() {
    this.EVENTS = COMPONENT_EVENTS;
    this.text.errors = {};
    this.text.errors.mandatory = this.$t('Common.welcome');
  },
};
</script>

<template>
  <div>
    <CostAllocationFormComponent
      v-model="myCostAllocationMock"
      v-bind="costAllocationFormComponentProps"
      v-on="{
        [EVENTS.updateForm]: value => { form = value },
      }"
    />
  </div>
</template>
